import React from 'react';

import { snakeCase } from 'lodash';
import { DefaultTooltip } from 'twyne-new.ui';

const buildItemsTips = tipsMap => ({ field }) => {
  const key = snakeCase(field)
  const tip = tipsMap[key]

  return <span>
    <DefaultTooltip content={tip}>
      {field}
    </DefaultTooltip>
  </span>
}

export default {
  emailVerification: {
    header: 'The verification of email (not-verified, valid, invalid)',
    items: buildItemsTips({
      not_verified: 'The verification was disabled for this traffic.',
      valid: 'The verification was called and returned a valid result.',
      invalid: 'The verification was called and returned a invalid result.',
    }),
  },
  postalVerification: {
    header: 'The verification of postal (not-verified, valid, invalid)',
    items: buildItemsTips({
      not_verified: 'The verification was disabled for this traffic.',
      valid: 'The verification was called and returned a valid result.',
      invalid: 'The verification was called and returned a invalid result.',
    }),
  },
  phoneVerification: {
    header: 'The verification of phone (not-verified, valid, invalid)',
    items: buildItemsTips({
      not_verified: 'The verification was disabled for this traffic.',
      valid: 'The verification was called and returned a valid result.',
      invalid: 'The verification was called and returned a invalid result.',
    }),
  },
  botVerification: {
    header: 'The recaptcha service (not-verified, bot, not-bot)',
    items: buildItemsTips({
      not_verified: 'The recaptcha was disabled for this traffic.',
      not_bot: 'The recaptcha was active and returned a not-bot result.',
      bot: 'The recaptcha was active and returned a bot result.',
    }),
  },
  fraudVerification: {
    header: 'The verification of fraud (not-verified, fraud, not-fraud)',
    items: buildItemsTips({
      not_verified: 'The verification was disabled for this traffic.',
      not_fraud: 'The verification was called and returned a good or warn score.',
      fraud: 'The verification was called and returned a bad score or the call was dropped.',
    }),
  },
  fraudScore: {
    header: 'The result of fraud verification call (bad, good, warn) or internal evaluation (awaiting, throttle, drop).',
    items: buildItemsTips({
      good: 'Good traffic. Not fraud.',
      warn: 'Suspicious traffic.',
      bad: 'Fraudlent traffic.',
      throttle: 'The fraud verification was not called because of the allocation trottle.',
      drop: 'The verifcation could not be completed successfuly on the client browser.',
      awaiting: 'The fraud check was waiting and was not called.',
    }),
  },
  conversion: {
    header: 'The session conversion type (not-verified, valid, invalid)',
    items: buildItemsTips({
      fraud: 'Fraud verification considered the traffic as fraud and the conversion was blocked. This metric depends on the "Fraud Verification" but they are not the same.',
    }),
  },
  payout: undefined,
}
